<template>
  <div class="sources">
    <div class="label">{{ $t('search.aiAnswer.sources') }}:</div>
    <ul
      class="sources-list"
      :aria-label="$t('search.aiAnswer.sources')"
    >
      <li
        v-for="(source, index) in sources"
        :key="`source-${index}-${source.url}`"
        class="source-item"
      >
        <a
          :href="source.url"
          class="pill"
          :aria-label="$t('search.aiAnswer.source', { index: index + 1, url: source.url })"
          target="_blank"
          rel="noopener noreferrer"
          @click.stop
        >
          <div class="favicon-container">
            <img
              :src="getFaviconUrl(source.url)"
              alt=""
              class="favicon"
            />
          </div>

          <span
            v-if="index === 0"
            class="url-title"
          >
            {{ source.title }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
  sources: {
    type: Array,
    default: () => [],
  },
});

const isRelativeUrl = (url) => {
  return url.startsWith('/') && !url.startsWith('//');
};
// Google api to get the favicon url
const getFaviconUrl = (url) => {
  let domain;

  try {
    if (isRelativeUrl(url)) {
      domain = window.location.hostname.replace('www.', '');
    } else if (url.startsWith('//')) {
      domain = new URL(`https:${url}`).hostname.replace('www.', '');
    } else {
      domain = new URL(url).hostname.replace('www.', '');
    }
  } catch (error) {
    console.warn('Failed to parse URL for favicon:', url, error);
    domain = window.location.hostname.replace('www.', '');
  }

  return `https://www.google.com/s2/favicons?domain=${domain}&sz=32`;
};
</script>

<style lang="scss" scoped>
.sources {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.label {
  font-size: 12px;
  font-weight: 400;
  line-height: 26px;
  color: var(--color-text-primary);
}

.sources-list {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.source-item {
  margin: 0;
  padding: 0;

  &:first-child {
    .pill {
      padding-right: 8px;
    }
  }
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  background: #fff;
  border: 1px solid var(--color-grey-200);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 100%;
  text-decoration: none;
  color: inherit;

  &:hover {
    background: var(--color-blue-100);
    text-decoration: none;
  }
}

.favicon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.favicon {
  width: 16px;
  height: 16px;
  object-fit: cover;
  aspect-ratio: 1/1;
  border-radius: 999px;
}

.url-title {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-blue-500);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
  min-width: 0;
  max-width: 200px;
}
</style>
